import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ssoenabled: null,
    forgotPasswordEnabled: null,
    keycloakIntegrationEnabled: null,
};

const featureFlagSlice = createSlice({
    name: 'featureFlag',
    initialState,
    reducers: {
        setFeatureFlag(state, { payload }) {
            const { key, value } = payload;
            if (key in state) {
                state[key] = value;
            }
        },
        getFeatureFlagData() { },
    },
});

export const featureFlagActions = featureFlagSlice.actions;
export const featureFlagReducer = featureFlagSlice.reducer;